





















import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';

const cssPrefix = 'sw-form-row-error';

@Component
export default class SwFormRowError extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ type: Array, default() { return []; } })
  error: String[];
}
